import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as staffAttendanceService from "../service/staffAttendanceService";
import type { StaffAttendanceState, MarkStaffAttendancePayload } from "../types";
import i18n from "@/i18n";

export const fetchRoster = createAsyncThunk(
  "staffAttendance/fetchRoster",
  async ({ institutionId, date }: { institutionId: number; date: string }) => {
    return await staffAttendanceService.fetchRoster(institutionId, { date });
  }
);

export const markAttendance = createAsyncThunk(
  "staffAttendance/markAttendance",
  async ({ institutionId, payload }: { institutionId: number; payload: MarkStaffAttendancePayload }) => {
    return await staffAttendanceService.markAttendance(institutionId, payload);
  }
);

export const fetchSummary = createAsyncThunk(
  "staffAttendance/fetchSummary",
  async ({ institutionId, from, to }: { institutionId: number; from?: string; to?: string }) => {
    return await staffAttendanceService.fetchSummary(institutionId, { from, to });
  }
);

const initialState: StaffAttendanceState = {
  roster: [],
  summary: [],
  loading: false,
  saving: false,
  error: null,
};

const staffAttendanceSlice = createSlice({
  name: "staffAttendance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoster.fulfilled, (state, action) => {
        state.loading = false;
        state.roster = action.payload;
      })
      .addCase(fetchRoster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? i18n.t("staffAttendance:staffAttendanceSlicetsMsgs.failedToLoadRoster");
      })
      .addCase(markAttendance.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(markAttendance.fulfilled, (state, action) => {
        state.saving = false;
        state.roster = action.payload;
      })
      .addCase(markAttendance.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error.message ?? i18n.t("staffAttendance:staffAttendanceSlicetsMsgs.failedToSaveAttendance");
      })
      .addCase(fetchSummary.fulfilled, (state, action) => {
        state.summary = action.payload;
      });
  },
});

export default staffAttendanceSlice.reducer;
